import { motion } from "framer-motion";
import { MaskLines, Eyebrow } from "./Motion";

export const PageHero = ({ eyebrow, lines, intro, testId }) => (
  <section data-testid={testId} className="relative overflow-hidden pb-16 pt-36 sm:pb-20 sm:pt-44">
    <div className="grid-lines absolute inset-0 [mask-image:radial-gradient(ellipse_at_top_left,black_30%,transparent_75%)]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1 className="font-display mt-6 text-5xl font-extrabold leading-[0.95] tracking-tight text-[#0B132B] sm:text-6xl lg:text-7xl">
        <MaskLines lines={lines} delay={0.1} />
      </h1>
      <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.5 }} className="mt-8 max-w-2xl text-base leading-relaxed text-slate-600 md:text-lg">
        {intro}
      </motion.p>
    </div>
  </section>
);
